import React,{useState} from "react";
import Navbar1 from "./Components/Navbar1";
import TextArea from "./Components/TextArea";
import Alert from "./Components/Alert";
function App() {
const [modeText,setModetext]=useState("light");
const [alert, setAlert] = useState(null);

const showAlert = (message, type)=>{
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(() => {
        setAlert(null);
    }, 1500);
}

const changeModefxn = () => {
  if (modeText === 'light') {
      setModetext('dark');
      document.body.style.backgroundColor = 'grey';
      showAlert("Dark mode has been enabled", "success");
  }
  else {
      setModetext('light');
      document.body.style.backgroundColor = 'white';
      showAlert("Light mode has been enabled", "success");
  }
};
  return (
    <div className="App"> 
      <Navbar1 title="PlayvdText" modeText={modeText} changeModefxn={changeModefxn}></Navbar1>
      <Alert alert={alert}/>
      <TextArea showAlert={showAlert} modeText={modeText}></TextArea>
    </div>
  );
}

export default App;
